export type FilterAccess = {
  noUsers: boolean;
  noSchedule: boolean;
  noDevices: boolean;
};

export type UserGroupFilter = {
  filterAccess: FilterAccess;
  filterOfficeMode: FilterOfficeMode;
};

export const FilterOfficeMode = {
  Allowed: 'allowed',
  NotAllowed: 'notAllowed'
} as const;

export type FilterOfficeMode = (typeof FilterOfficeMode)[keyof typeof FilterOfficeMode] | null;

export type UserGroupFilterSetters = {
  setFilterAccess: (value: FilterAccess | ((current: FilterAccess) => FilterAccess)) => void;
  setFilterOfficeMode: (value: FilterOfficeMode) => void;
};

export interface UserGroupFilterState {
  filter: UserGroupFilter;
  setters: UserGroupFilterSetters;
  clearAllFilters: () => void;
  isAnyFilterEnabled: boolean;
}
